import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

export interface NmiConfig {
  /** Base URL of the NMI WebAPI e.g. 'https://your-nmi-api.com' */
  apiUrl: string;

  /**
   * API key for server-to-server or external client auth.
   * Sent as X-Api-Key header. Use this instead of tokenFn
   * when your app has a static key issued by the NMI admin.
   *
   * Example:
   *   apiKey: 'nmi_xxxxxxxxxxxxxxxx'
   */
  apiKey?: string;

  /**
   * Function that returns the JWT for each request.
   * Return the JWT from your existing app's login response.
   * Can return a plain string, Promise, or Observable.
   * Required when apiKey is not set.
   *
   * Example (store2):
   *   tokenFn: () => store.get('token') as string
   */
  tokenFn?: () => string | Promise<string> | Observable<string>;

  /**
   * Optional: BranchId to send as X-Branch-Id header.
   * Required only if a JWT user can belong to multiple branches.
   * Can be a static string or a function that returns one.
   *
   * Example (store2):
   *   branchId: () => store.get('userbranches') as string
   */
  branchId?: string | (() => string);
}

export const NMI_CONFIG = new InjectionToken<NmiConfig>('NMI_CONFIG');
